import { Box, Grid, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { CustomKeyValue } from "../../components";

function TransactionDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id || "";
  
  const transaction = useSelector((state: RootState) => state.transaction[id]);

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("transaction_detail")}
        </Typography>
      </Stack>

      <Box
        sx={{
          backgroundColor: "white",
          boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)",
          height: "400px",
        }}
      >
        <Grid container sx={{ p: 3 }} rowSpacing={3}>
          <Grid item xs={3}>
            <CustomKeyValue title={"Date"} value={new Date(transaction.dateCreation).toLocaleDateString()} />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={i18n.t("valeur")} value={transaction.valeur} />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={"Type"} value={transaction.typeOperation} />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={i18n.t("statut")} value={i18n.t(transaction.statutTransaction)} />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={i18n.t("emetteur")} value={transaction.emetteur?.telephone} />
          </Grid> 
        </Grid>
        <Grid container sx={{ p: 3 }} rowSpacing={3}>
          <Grid item xs={3}>
            <CustomKeyValue
              title={i18n.t("nom_prenom_emetteur")}
              value={`${transaction.emetteur?.nom} ${transaction.emetteur?.prenom}`}
            />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={i18n.t("mode_paiement")} value={i18n.t(transaction.moyenOperation)} />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue
              title={i18n.t("numero_transaction")}
              value={transaction.numeroTransaction}
            />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={"Description"} value={transaction.description} />
          </Grid>
          <Grid item xs={3}>
            <CustomKeyValue title={i18n.t("createur")} value={`${transaction.destinataire?.nom} ${transaction.destinataire?.prenom}`} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default TransactionDetail;
